var map = {
	"./de": [
		"4113",
		"chunk-2d0c0255"
	],
	"./de.vue": [
		"4113",
		"chunk-2d0c0255"
	],
	"./en": [
		"bd36",
		"chunk-2d21ab1b"
	],
	"./en.vue": [
		"bd36",
		"chunk-2d21ab1b"
	],
	"./it": [
		"75f8",
		"chunk-2d0d74e6"
	],
	"./it.vue": [
		"75f8",
		"chunk-2d0d74e6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8531";
module.exports = webpackAsyncContext;